import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	position: fixed;
	height: calc(var(--vh, 1vh) * 100);
	width: 100vw;
	top: 0;
	left: 0;
	background: rgba(41, 24, 94, 0.41);
	backdrop-filter: blur(8px);
	z-index: 90;
`;

export const WhiteBox = styled.div`
	height: fit-content;
	width: 100%;
	border-radius: 16px 16px 0px 0px;
	background: #f4f6f8;
	padding-bottom: 10px;
`;

export const TopContent = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px 12px 0 12px;
`;

export const CloseIcon = styled.img`
	width: 12px;
	height: 12px;
	cursor: pointer;
`;

export const MiddleContentWrappper = styled.div`
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	padding: 0px 16px;
	gap: 8px;
`;

export const HandleBar = styled.div`
	width: 97px;
	height: 4px;
	flex-shrink: 0;
	border-radius: 8px;
	background: #d9d9d9;
`;

export const Title = styled.div`
	color: #29185e;
	text-align: center;
	font-family: Lato;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: 123.5%; /* 17.29px */
	letter-spacing: 0.28px;
`;

export const Description = styled.div`
	color: #29185e;
	font-family: Lato;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 123.5%; /* 14.82px */
	letter-spacing: 0.24px;
	text-align: left;
	box-sizing: border-box;
`;

export const TasksWrapper = styled.div`
	display: flex;
	flex-direction: column;
	background-color: white;
	gap: 8px;
	border-radius: 8px;
	box-sizing: border-box;
	padding: 8px 0;
`;

export const Task = styled.div`
	color: var(--Text-color, #29185e);
	font-family: Lato;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 123.5%; /* 17.29px */
	letter-spacing: 0.28px;
	text-align: left;
	box-sizing: border-box;
	padding: 3px 10px;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
`;

export const Spacer = styled.div`
	width: 100%;
	height: 1px;
	background-color: #f4f6f8;
`;
